export default "/images/framework/DownloadEng.254d786e.svg?254d786e";